/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".locate-main[_ngcontent-%COMP%]   .pop-up-heading[_ngcontent-%COMP%]{color:#1f1f21;font-size:40px;letter-spacing:-1.36px;line-height:65px;padding-top:5%;padding-left:2%}.locate-main[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]{float:right;width:12%}.mapouter[_ngcontent-%COMP%]{position:relative;text-align:right;width:100%;padding-bottom:1%}.gmap_canvas[_ngcontent-%COMP%]{overflow:hidden;background:0 0!important;width:100%}iframe[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
